import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { templateManageRoute } from './manage.route';
import { templateStatusesRoute } from './steps/statuses.route';

export const templateEditRoute: RouteConfig = {
  ...templateManageRoute(
    ':templateId',
    'templateEdit',
    'Edycja wzoru procedury',
    [
      { title: 'Nazwa', name: 'templateEditName' },
      { title: 'Statusy', name: 'templateEditStatuses' }
    ],
    [templateStatusesRoute]
  ),
  beforeEnter: (to, from, next) => {
    store
      .dispatch('template/get', parseInt(to.params.templateId))
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.TEMPLATE_CANNOT_GET }));
  }
};
